var React = require('react');

function ZoomIn (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Zoom In"),React.createElement("path",{"d":"M23 11H13V1a1 1 0 0 0-2 0v10H1a1 1 0 0 0 0 2h10v10a1 1 0 0 0 2 0V13h10a1 1 0 0 0 0-2","key":1})]);
}

ZoomIn.displayName = "ZoomIn";

ZoomIn.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ZoomIn;

ZoomIn.default = ZoomIn;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/zoom-in.svg
// module id = 1288
// module chunks = 0